import { createSelector } from "reselect";
import { selectIsOneNodeSupported } from "common/user/UserSelectors";

export const getShowDistributeSelect = createSelector(selectIsOneNodeSupported, (isOneNodeSupported: boolean) => {
  return !isOneNodeSupported;
});
